export default "__VITE_ASSET__CFBgnZVS__"